module.exports = __webpack_public_path__ + "img/1534500084.01278e58.jpg";